import { useMutation, useQueryClient } from '@tanstack/react-query';
import { departmentsKeys } from 'store/departments';
import { loaders } from './teams.loaders';
import { teamsKeys } from './teams.queries';

export const useCreateTeam = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createTeam, {
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries(teamsKeys.all),
        queryClient.invalidateQueries(departmentsKeys.all),
      ]);
    },
  });
};

export const useUpdateTeam = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateTeam, {
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries(teamsKeys.all),
        queryClient.invalidateQueries(departmentsKeys.all),
      ]);
    },
  });
};

export const useDeleteTeam = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteTeam, {
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries(teamsKeys.all),
        queryClient.invalidateQueries(departmentsKeys.all),
      ]);
    },
  });
};
